export { AppLayout as default } from '@/src/general/ui/layouts/AppLayout'
